import { render, staticRenderFns } from "./MinistryBreadcrumbs.vue?vue&type=template&id=18e28baa&"
import script from "./MinistryBreadcrumbs.vue?vue&type=script&lang=js&"
export * from "./MinistryBreadcrumbs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports